import { useUserInfo } from "@/context/UserInfo";
import { Box, Switch, SystemStyleObject } from "@chakra-ui/react";

const CurrencySwitch = ({
  onChange,
  checked,
  sx,
}: {
  onChange: () => void;
  checked: boolean;
  sx?: SystemStyleObject;
}) => {
  const { currencyInfo, handleShowBalance } = useUserInfo();

  return (
    <Box
      sx={{
        display: currencyInfo.localCurrency === "USD" ? "none" : "block",
      }}
    >
      <Switch
        onChange={() => {
          onChange();
          handleShowBalance(true);
        }}
        checked={checked}
        defaultChecked={checked}
        size="lg"
        colorScheme="orange"
        sx={{
          overflow: "hidden",
          position: "relative",

          "span.chakra-switch__track": {
            backgroundColor: "#FFD096",
            border: "1px solid #FFD096",
            width: "65px !important",
            height: "28px !important",
            position: "relative",
          },
          "span.chakra-switch__thumb": {
            backgroundColor: "#D8762B",
            width: "28px !important",
            height: "28px !important",
            position: "relative",
            "&::before": {
              content: checked ? `"${currencyInfo.localCurrency}"` : '"USD"',
              position: "absolute",
              color: "#D8762B",
              fontSize: "12px",
              left: checked ? "-30px" : "35px",
              top: "50%",
              transform: "translateY(-50%)",
              fontWeight: 700,
            },
          },
          "&[data-checked] span.chakra-switch__track": {
            backgroundColor: "#FFFFFF",
          },
          "&[data-checked] span.chakra-switch__thumb": {
            backgroundColor: "#D8762B",
            transform: "translateX(37px) !important",
          },
          ...sx,
        }}
      />
    </Box>
  );
};

export default CurrencySwitch;
